import { useMediaQuery } from 'react-responsive';

export default function useMediaBreakpoints() {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' });
  const isMiddleScreen = useMediaQuery({ query: '(max-width: 1000px)' });
  const isBigScreenMinWidth = useMediaQuery({ query: '(min-width: 1800px)' });

  return { isTabletOrMobile, isMobile, isBigScreenMinWidth, isMiddleScreen };
}
